import React from 'react';
import './CS.css';
import { NavLink } from 'react-router-dom';
import PageNavigator from "../../../components/PageNavigator";

function CS0() {
  return (
    	<div className='CS'>
    	<PageNavigator group="CS" />
    		<p className='heading1'>Capital Structure</p>
            <div style={{ display: "flex", paddingLeft: "10vw"}}>
            <ul className='toc-list'>
                <div className='content-group'>
                    <li><NavLink className='CS-link' to="/corporate_finance/capital_structure/mm">Modigliani-Miller Theorem</NavLink></li>
                    <ul className='toc-list'>
                        <li className='CS-content'>Capital Structure Basics</li>
                        <li className='CS-content'>Modigliani-Miller Assumptions</li>
                        <li className='CS-content'>Modigliani-Miller Proof</li>
                        <li className='CS-content'>Intuition</li>
                        <li className='CS-content'>Numerical Example</li>
                        <li className='CS-content'>Examples</li>
                    </ul>
                    <li><NavLink className='CS-link' to="/corporate_finance/capital_structure/mm_departures">Departures from Irrelevance Result</NavLink></li>
                    <ul className='toc-list'>
                        <li className='CS-content'>MM Assumptions Revisited</li>
                        <li className='CS-content'>Taxes</li>
                        <li className='CS-content'>Financial Distress and Bankruptcy Costs</li>
                        <li className='CS-content'>The Trade-Off Theory</li>
                        <li className='CS-content'>Asymmetric Information</li>
                        <li className='CS-content'>Agency Problems</li>
                        <li className='CS-content'>Different Borrowing Rates</li>
                        <li className='CS-content'>Market Power and Transaction Costs</li>
                        <li className='CS-content'>Putting It All Together</li>
                    </ul>
                    <li><NavLink className='CS-link' to="/corporate_finance/capital_structure/wacc">Weighted Average Cost of Capital</NavLink></li>
                    <ul className='toc-list'>
                        <li className='CS-content'>Valuation Discount Rate</li>
                        <li className='CS-content'>Perpetuity Assumption</li>
                        <li className='CS-content'>Cash Flow Decomposition</li>
                        <li className='CS-content'>Estimating the WACC</li>
                        <li className='CS-content'>Market Estimates</li>
                        <li className='CS-content'>Taxes</li>
                        <li className='CS-content'>The After-Tax WACC</li>
                        <li className='CS-content'>Numerical Example</li>
                        <li className='CS-content'>Examples</li>
                    </ul>
                </div>
            </ul>
            </div>
    	<PageNavigator group="CS"/>
        </div>
  );
}

export default CS0;